// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"480":"8082b682","530":"76ef2550","590":"56cedeeb","787":"a05872c4"}[chunkId] + ".chunk.js";
};